import * as i0 from '@angular/core';
import * as i1 from './collapse.module';
import * as i2 from './collapse';
export const NgbCollapseModuleNgFactory:i0.NgModuleFactory<i1.NgbCollapseModule> = (null as any);
var _decl0_0:i2.NgbCollapse = (<any>(null as any));
